import { Spreekballon } from "../Spreekballon";

export type ExamTopBarProps = {
  /** The part-progress dot strip (compact <PartProgress … compact />). */
  progress: React.ReactNode;
  /** Timer + settings cluster (<TimerPill/> + optional <OverallTimer/> + cog). */
  timers: React.ReactNode;
  /** The X-to-exit affordance (<SluitenButton/>). */
  exit: React.ReactNode;
  modeLabel?: string;
};

/**
 * Slim top bar for the non-DUO (Ember) exam focus surface. Sticky, panel
 * fill, hairline bottom border. Renders the brand mark + "Oefenmodus" pill,
 * the part-progress strip (centered), the timer cluster, and the exit X.
 *
 * On mobile (<lg) the wordmark drops to just the mark, and the part-progress
 * label is hidden by the compact PartProgress variant.
 */
export function ExamTopBar({
  progress,
  timers,
  exit,
  modeLabel = "Oefenmodus",
}: ExamTopBarProps) {
  return (
    <header className="sticky top-0 z-20 flex items-center gap-3 sm:gap-4 border-b border-[var(--border)] bg-[var(--panel)] px-4 py-3 sm:px-6 sm:py-4">
      <span className="flex items-center gap-2 shrink-0">
        <Spreekballon size={26} />
        <span className="hidden sm:inline font-display text-[17px] font-semibold tracking-tight">
          <span className="text-[var(--accent)]">A2</span> Easy
        </span>
      </span>

      <span className="hidden sm:inline-flex items-center gap-1.5 rounded-full bg-[var(--accent-soft)] px-2.5 py-1 font-mono-badge text-[10px] uppercase tracking-wider text-[var(--accent)] shrink-0">
        <span aria-hidden className="inline-block h-1.5 w-1.5 rounded-full bg-[var(--accent)]" />
        {modeLabel}
      </span>

      <div className="min-w-0 flex-1 flex justify-center">{progress}</div>

      <div className="flex items-center gap-2 sm:gap-3 shrink-0">
        {timers}
        {exit}
      </div>
    </header>
  );
}
